import React from 'react'
import { BiBasket } from 'react-icons/bi'
import FormatCurrency from '../../utils/FormatCurrency'

function SaleCom({ color, title, amount }) {

    let bg = "bg-[#4fd1b3]";

    switch (color) {
        case "blue":
            bg = "bg-[#2676ff]"
            break;
        case "purple":
            bg = "bg-[#7747c9]";
            break
        case "pink":
            bg = "bg-[#fa7ab8]";
            break
        case "dark":
            bg = "bg-[#4c5459]";
            break
        default:
            break;
    }

    return (
        <div>
            <div className="bg-white space-y-3 border rounded-2xl px-5 py-4">
                <p className="text-gray-400 font-medium text-xs uppercase">{title}</p>
                <div className='flex items-center gap-2'>
                    <div className={`size-8 rounded-lg ${bg} text-white flex justify-center items-center`}>
                        <BiBasket size={18} />
                    </div>
                    <div>
                        <h1 className="text-lg font-bold">
                            <FormatCurrency amount={amount} />
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SaleCom